import { ref, getCurrentInstance, reactive, computed } from 'vue'

// Dev-only: skip Google reCAPTCHA when VUE_APP_RECAPTCHA_BYPASS=true (backend must run with TEST_MODE=true).
// `vue-cli-service build` always sets NODE_ENV=production, so the bypass can never ship.
const bypassRecaptcha = process.env.NODE_ENV !== 'production' && process.env.VUE_APP_RECAPTCHA_BYPASS === 'true'

export const useRecaptcha = () => {
  const { proxy } = getCurrentInstance()
  const showV2Recaptcha = ref(false)
  const recaptchaVersionFailed = reactive({ v2: false, v3: false })
  const recaptchaVerifyToken = ref(null)
  const recaptchaVersionUse = computed(() => {
    if (recaptchaVersionFailed.v3) return 'v2'
    return 'v3'
  })

  const v3RecaptchaVerify = async (action) => {
    if (bypassRecaptcha) {
      recaptchaVerifyToken.value = 'dev-bypass'
      return
    }
    try {
      await proxy.$recaptchaLoaded()
      const token = await proxy.$recaptcha(action)
      recaptchaVerifyToken.value = token
    } catch (error) {
      window.$message.error('v3RecaptchaVerify error')
      console.log('v3RecaptchaVerify error', error)
    }
  }

  const v2RecaptchaVerify = async (token, callBack) => {
    recaptchaVerifyToken.value = token
    callBack()
  }

  const handleRecaptchaError = (errorCode) => {
    recaptchaVerifyToken.value = null
    if (errorCode === 'RECAPTCHA_V3_INCORRECT') {
      recaptchaVersionFailed.v3 = true
      showV2Recaptcha.value = true
      return true
    }
    return false
  }

  return {
    recaptchaVerifyToken,
    v3RecaptchaVerify,
    recaptchaVersionFailed,
    recaptchaVersionUse,
    showV2Recaptcha,
    v2RecaptchaVerify,
    handleRecaptchaError,
  }
}
